import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Loading from "components/Loading/Loading";
import { Empty } from "shared/Notifications/Error";
import { useDispatch, useSelector } from "react-redux";
import Table from "components/Table/Table";
import {
  deleteAllOrdersAction,
  getAllOrdersAction,
  resetOrderState,
} from "../../redux/features/orderSlide";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import CommonLayout from "containers/AccountPage/CommonLayout";
import SideBar from "containers/UserDashboard/SideBar"; // ✅ Import your sidebar
import SidebarMenu from "containers/UserDashboard/SideBarMenu";

const ListingOrders = () => {
  const dispatch = useDispatch();

  // Select state from Redux
  const { orders, loading, error, success } = useSelector(
    (state) => state.order
  );

  console.log({ orders });

  // Fetch all orders when the component mounts or after a delete operation succeeds
  useEffect(() => {
    dispatch(getAllOrdersAction());

    // Optionally reset state after re-fetch
    if (success) {
      dispatch(resetOrderState());
    }
  }, [dispatch, success]);

  const deleteAllOrdersHandler = () => {
    if (window.confirm("All orders will be deleted")) {
      dispatch(deleteAllOrdersAction());
    }
  };

  const deleteLoading = false;

  return (
    <div className="bg-gray-900 text-white min-h-screen pb-8 pt-12 px-4">
      <div className="container mx-auto px-2">
        <div className="xl:grid grid-cols-8 gap-10 items-start md:py-12 py-6">
          <div className="hidden md:block sticky col-span-2 bg-gray-800 p-6 rounded-md xl:mb-0 mb-5">
            <SidebarMenu />
          </div>
          {loading ? (
            <div className="flex-colo h-96 col-span-6">
              <Loading />
            </div>
          ) : (
            <div
              data-aos="fade-up"
              key={loading ? "loading" : "loaded"}
              className="col-span-6 rounded-md bg-gray-800 p-6"
            >
              <div className="flex flex-col gap-4">
                <div className="flex justify-between items-center gap-2">
                  <h2 className="text-xl font-bold">Order History</h2>
                  {orders?.length > 0 && (
                    <ButtonPrimary
                      disabled={deleteLoading}
                      onClick={deleteAllOrdersHandler}
                      className="bg-flash font-medium text-white py-2 px-6 rounded"
                    >
                      Delete All
                    </ButtonPrimary>
                  )}
                </div>

                {orders?.length === 0 ? (
                  <div className="flex-colo h-96">
                    <Empty text={"No order found"} />
                  </div>
                ) : (
                  <Table datas={orders} dashboard={false} />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListingOrders;
